var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-spinner',{staticClass:"mr-1",attrs:{"variant":_vm.variant}})}
var staticRenderFns = []

export { render, staticRenderFns }